import _ from 'lodash';
import moment from 'moment';

export function prepEagerUpdate(data, updates) {
  const updated = _.assign({}, data, updates);
  updated.locked = moment().add(30, 'seconds').toDate();
  updated.updatedAt = moment().toDate();

  return updated;
}



// WEBPACK FOOTER //
// ./app/utils/eager-update-utils.js